<template>
    <div>
        <v-dialog v-model="openDialog" persistent width="500px">
            <v-card style="overflow: hidden">
                <v-card-title>
                    {{ $t('layout.select_project') }}
                </v-card-title>
                <v-divider/>
                <v-card-text style="height: 350px; overflow-y: auto">
                    <v-list>
                        <v-list-item-group
                            v-model="projectIndex"
                            active-class="primary--text"
                        >
                            <v-list-item 
                                v-for="projectOption in projects" 
                                :key="projectOption._id"
                                :disabled="project === projectOption.name"
                            >
                                <template v-slot:default="{ active }">
                                    <v-list-item-icon>
                                        <v-icon>mdi-package</v-icon>
                                    </v-list-item-icon>
    
                                    <v-list-item-content>
                                        <v-list-item-title
                                            class="text-uppercase"
                                            :class="{ 'font-weight-bold': active }"
                                        >
                                            {{ projectOption.name }}
                                        </v-list-item-title>
                                    </v-list-item-content>
    
                                    <v-list-item-action>
                                        <v-icon v-if="active" color="primary">
                                            mdi-check
                                        </v-icon>
                                    </v-list-item-action>
                                </template>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <p class="red--text ma-2">
                        {{ errorMessage }}
                    </p>
                    <v-btn text @click="close()">
                        {{ $t('common.cancel') }}
                    </v-btn>
                    <v-btn 
                        color="primary"
                        @click="selectingProject()"
                    >
                        {{ $t('common.select') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
    name: 'ProjectDialog',
    props: {
        openDialog: { type: Boolean, default: false },
    },
    computed: {
        ...mapState({
            projects: (state) => state.user.projects,
            project: (state) => state.project.name,
        }),
    },
    data() {
        return {
            projectIndex: null,
            errorMessage: '',
        }
    },
    methods: {
        ...mapMutations({
            setZones: 'zones/SET_ZONES',
            setSchedules: 'schedules/SET_LIST',
            setNodes: 'nodes/SET_NODES',
            setLayouts: 'layouts/SET_LIST',
        }),
        ...mapActions({
            setProject: 'project/setProject',
            fetchGateways: 'gateways/fetchGateways'
        }), 
        async selectingProject() {
            try {
                this.errorMessage = ''
                if(!(this.projectIndex >= 0)) {
                    throw new Error('Please select a project')
                }
                await this.setProject(this.projects[this.projectIndex])
                localStorage.removeItem('gateways')
                await this.fetchGateways()
                this.$router.push({ name: 'home' }).catch(() => {})
                this.$emit('close')
                this.setZones([])
                this.setSchedules([])
                this.setNodes([])
                this.setLayouts([])
            } catch (error) {
                this.errorMessage = error.data || error.message
                this.projectIndex = null
            }
        },
        close() {
            this.errorMessage = ''
            this.$emit('close')
        },
    },
    watch: {
        openDialog(){
            this.projectIndex = this.projects.findIndex(project => project.name_eui === this.project)
        }
    }

}
</script>

<style scoped>
.projectText{
    font-size: 16px;
    text-transform: uppercase;
    position: relative;
    top: 7px;
}
</style>
